import { gql } from "apollo-boost";

const BULK_SUPPLIER_ACTION = gql`
  mutation bulkSupplierAction($input: BulkAction!) {
    bulkSupplierAction(input: $input) {
      data
      status
      error
    }
  }
`;

const PROXY_LOGIN = gql`
  mutation proxyLogin($input: ProxyLogin) {
    proxyLogin(input: $input) {
      data {
        token
      }
      status
      error
    }
  }
`;

const DELETE_VENDOR_ASSOCIATION = gql`
  mutation deleteVendorAssociation($input: DeleteVendorAssociation!) {
    deleteVendorAssociation(input: $input) {
      status
      error
      data
    }
  }
`;

const ENABLE_DISABLE_VENDOR = gql`
  mutation updateVendorAvailability($input: EnableDisable) {
    updateVendorAvailability(input: $input) {
      data
      status
      error
    }
  }
`;

export { BULK_SUPPLIER_ACTION, DELETE_VENDOR_ASSOCIATION, ENABLE_DISABLE_VENDOR, PROXY_LOGIN };
